module.exports = __webpack_public_path__ + "img/pe.c79217ea.svg";